import styled from 'styled-components';

export const MobileHistoryDateRowStyled = styled.div`
    display: flex;
    justify-content: end;
    padding: 28px 16px 12px;
    font-size: 14px;
    font-weight: 500;
    color: var(--color-white);
`;
